import { Banner } from '@/components/ui/banner'
import type { DriverMvrState } from '@/models/mvr'

/** Tells staff when MVRs show accidents the customer reported as none, so they raise it before quoting. */
export function UnreportedAccidentsBanner({ states }: { states: DriverMvrState[] }) {
  const flagged = states.filter((state) => state.unreportedAccidents > 0)
  if (flagged.length === 0) return null

  const drivers = flagged.length === 1 ? '1 driver' : `${flagged.length} drivers`
  return (
    <Banner variant="warning" small>
      The customer reported no at-fault accidents for {drivers}, but their MVR shows accidents. Talk to the
      customer before quoting.
    </Banner>
  )
}
